import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsEhmsConstants {
    static STEP_TITLE = "Details";
    static REFERENCE_NUMBER_LABEL = "Reference Number";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static START_DATE_LABEL = "Application Start Date";
    static COMMUNICATION_METHOD_LABEL = "Communication Method";
    static REFERENCE_NUMBER_FORM_CONTROL_NAME = "reference";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static START_DATE_FORM_CONTROL_NAME = "startDate";
    static COMMUNICATION_METHOD_FORM_CONTROL_NAME = "communicationMethod";
    static COMMUNICATION_METHOD_LOOKUP_TYPE = "communicationMechanism";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        communicationMethod: {
            required: `Communication method type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        startDate: {
            required: `Start date ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
